import Vue from 'vue';
import Vuex from 'vuex';
import { AppModule } from './modules/app';
import { UserConfModule } from './modules/userConf';
import { SaveUserConf } from './plugins/SaveUserConf';
import { ThemeConfModule } from '@/store/modules/theme';

import TOC from '@/views/toc.json';

Vue.use(Vuex);

export interface IRootState {
  userId: string;
}

const rootState = { userId: '' };
const getters = {
  storagePrefix: (state: IRootState) => {
    return `st-conf-${state.userId}`;
  },
  storagePrefixCourse: (state: IRootState) => {
    return `${TOC.name}-${state.userId}`;
  }
};

export const store = new Vuex.Store<IRootState>({
  state: rootState,
  getters: getters,
  mutations: {
    SET_USER_ID(state, userId) {
      state.userId = userId;
    }
  },
  modules: {
    app: AppModule,
    userConf: UserConfModule,
    theme: ThemeConfModule
  },
  plugins: [SaveUserConf]
});

export default store;